<template>
  <div class="anhui">
    <div class="anhui-header">
      <div class="bar-header">
        <a
          v-for="item in children"
          :key="item.path"
          :class="[isActiveFn(item)]"
          @click="handleTab(item)"
          >{{ item.meta.name }}</a
        >
      </div>
    </div>
    <div class="anhui-contanier">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { routes } from '@/router/index'
export default {
  name: 'Anhui',
  data(){
    return{
      isCRSW:false,
      navData:[],
    }
  },
    created(){
  },
  computed: {
    children() {
      const children = routes[0].children.find(
        (route) => route.path && this.$route.path.includes(route.path)
      )?.children
      return children || []
    },
  },
  methods: {
    isActiveFn(item) {
      return this.$route.path.includes(item.path)
        ? 'active-header'
        : 'item-header'
    },
    handleTab(item) {
      if (this.$route.path.includes(item.path)) return
      // 兼容之前布局，方便维护一份代码（安徽移动的银行保函和普通的银行保函）
      // 需求：安徽移动银行保函与普通银行保函流程保持一致（之前基本不同）
      this.$router.push({
        path: '/' + item.path,
        query: this.$route.query,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.anhui {
  width: 1200px;
  margin: 0 auto;
  background-color: white;
  padding: 20px;
  &-header {
    .bar-header {
      background: #edf5fa;
      height: 70px;
      display: flex;
      justify-content: flex-start;
      line-height: 70px;
      a:hover {
        border-top: 6px solid #3b85f4;
        font-size: 14px;
        color: #3b85f4;
        background: #ffffff;
      }
      .item-header {
        color: #333333;
        cursor: pointer;
        text-align: center;
        background: #edf5fa;
        width: 360px;
        height: 70px;
        border-top: 6px solid #edf5fa;
        font-size: 14px;
        line-height: 70px;
      }
      .active-header {
        cursor: pointer;
        text-align: center;
        // width: 360px;
        flex: 1;
        height: 70px;
        font-size: 14px;
        line-height: 70px;
        font-weight: bold;
        border-top: 6px solid #3b85f4;
        font-size: 14px;
        color: #3b85f4;
        background: #ffffff;
      }
    }
  }
}
.bar-header{
  a{
    flex: 1;
  }
}
</style>
